import { Component, inject, Input, OnInit } from '@angular/core';
import { UnleashService } from '@karelics/angular-unleash-proxy-client';
import { TranslateService } from '@ngx-translate/core';
import { GuardhouseService } from '@rd/core/services/guardhouse/guardhouse.service';
import { IconRegistryService } from '@rd/core/services/icon-registry/icon-registry.service';
import { CORE_AUTH_SECURE_ROUTE_DIALOG } from '@rd/core/tokens/popup.token';
import { DialogService } from '@rd/popup/services/dialog/dialog.service';
import { AuthRenderState } from '@rd/types';
import { ANZFeatureFlagService } from '../../services/anz-feature-flag.service';
import { ANZ_SSO_ENABLED } from '../../tokens/features.tokens';

type NonAuthUserActions = 'activate_account' | 'login';

@Component({
  selector: 'rd-anz-quick-access',
  templateUrl: './quick-access.component.html',
  styleUrls: ['./quick-access.component.scss'],
  standalone: false,
})
export class AnzQuickAccessComponent implements OnInit {
  @Input() authRenderState: AuthRenderState;

  changePasswordUrl: string;
  unleashService = inject(UnleashService);
  isAnzSSOEnabled = inject(ANZ_SSO_ENABLED);

  private coreAuthSecureRouteDialogComponentType = inject(
    CORE_AUTH_SECURE_ROUTE_DIALOG,
  );

  constructor(
    private dialogService: DialogService,
    private iconRegistryService: IconRegistryService,
    private guardhouseService: GuardhouseService,
    private translateService: TranslateService,
    public featureFlagService: ANZFeatureFlagService,
  ) {}

  ngOnInit(): void {
    this.iconRegistryService.registerIcon('activate');
    this.iconRegistryService.registerIcon('points-statement');
    this.iconRegistryService.registerIcon('change-password');
    this.iconRegistryService.registerIcon('redemptions');

    this.changePasswordUrl =
      this.guardhouseService.changePasswordUrl.toString();
  }

  handleNonLoggedInAction(action: NonAuthUserActions): void {
    switch (action) {
      case 'activate_account': {
        this.guardhouseService.redirectToEnrollUrl();
        break;
      }
      case 'login': {
        this.guardhouseService.redirectToLoginUrl();
        break;
      }
    }
  }

  handleChangePassword(e: Event): void {
    e.preventDefault();
    if (this.authRenderState === 'loggedOut') {
      this.dialogService.open(this.coreAuthSecureRouteDialogComponentType, {
        id: 'auth-secure-route-dialog',
        screenMode: 'center-md',
        ariaLabel: this.translateService.instant(
          'accessibility.core.auth_dialog_aria_label',
        ),
      });
    } else {
      this.guardhouseService.redirectToChangePasswordUrl();
    }
  }
}
